<div style="margin: 20px 20px 20px 20px;">
	<form>
		<div class="mb-3" style="margin-top: 0px;">
			<span class="device-header">Source Device:</span>

			<button type="button" pButton [disabled]="!enableSelectDevice"
					(click)="selectDevice()">{{deviceName}}</button>
		</div>
		<div class="mb-3" style="margin-top: 0px;">
			<span class="device-header">Target Device:</span>
			<button type="button" pButton [disabled]="!enableSelectDevice2"
					(click)="selectDevice2()">{{deviceName2}}</button>
		</div>

		<p-table #dt [value]="entries" [resizableColumns]="true"
				 [scrollable]="true" scrollHeight="calc(100vh - 92px - 20px - 48px - 60px - 40px + 6px)">

			<ng-template pTemplate="header">
				<tr>
					<th pResizableColumn="device">
						Device
					</th>
					<th pResizableColumn="ipaddress">
						IP Address
					</th>
					<th pResizableColumn="interface" [ngStyle]="{'width':'300px'}">
						Interface
					</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-rowData>
				<tr [pSelectableRow]="rowData">
					<td>
						<span class="uv-table-value">{{rowData.device}}</span>
					</td>
					<td>
						<span class="uv-table-value">{{rowData.ipaddress}}</span>
					</td>
					<td>
						<span class="uv-table-value">{{rowData.interface}}</span>
					</td>
				</tr>
			</ng-template>

		</p-table>
	</form>

	<device-selector [header]="'Select a Device'" [(visible)]="displayDeviceSelector" [minDevices]="1" [maxDevices]="1"
					 (onCancel)="onDeviceSelectorCancel()" (onOk)="onDeviceSelectorOk($event)">
	</device-selector>

	<device-selector [header]="'Select a Device'" [(visible)]="displayDeviceSelector2" [minDevices]="1" [maxDevices]="1"
					 (onCancel)="onDeviceSelectorCancel2()" (onOk)="onDeviceSelectorOk2($event)">
	</device-selector>


</div>
